import {TimeUnit} from '@linx-security/api-specs';

export const convertUnitToConstant = (unit: string) => {
  switch (unit.toLowerCase()) {
    case `day`:
    case `days`:
      return TimeUnit.Day;
    case `week`:
    case `weeks`:
      return TimeUnit.Week;
    case `month`:
    case `months`:
      return TimeUnit.Month;
    case `year`:
    case `years`:
      return TimeUnit.Year;
    default:
      return ``;
  }
};
